import type { CSSProperties, ReactNode } from 'react';

export type StageTone = 'board' | 'dark';

export type StageProps = {
  tone: StageTone;
  /** Apply the noir frame strip seen on the prototype's mobile/tablet shell. */
  withFrame?: boolean;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

/**
 * Background wrapper. The dossier defines two stage tones and every
 * page picks one:
 *  - `tone='board'`  → cork frame for splash, lobby, end (warm + lively).
 *  - `tone='dark'`   → noir radial for play screens (pass / reveal /
 *                      speak / discuss / vote / vote-reveal / clochard).
 *
 * `withFrame` adds the dossier's outer noir gradient so the frame reads
 * as a wooden border around mobile/tablet device chrome. Production
 * routes leave it off and let the cork or dark fill the viewport.
 */
export const Stage = ({ tone, withFrame, className, style, children }: StageProps) => {
  const cls = [
    'relative isolate flex h-full w-full flex-col',
    tone === 'board' ? 'dossier-board' : 'dossier-dark',
    withFrame ? 'p-5' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  const mergedStyle: CSSProperties = {
    paddingTop: 'env(safe-area-inset-top)',
    paddingBottom: 'env(safe-area-inset-bottom)',
    ...style,
  };
  return (
    <div className={cls} style={mergedStyle}>
      {children}
    </div>
  );
};
